import { Toaster as SonnerToaster, type ToasterProps } from "sonner";
import { useTheme } from "../../lib/useTheme.tsx";

type AppToasterProps = {
  routePath: string;
};

const toastClassNames = {
  toast: "comodo-toast",
  title: "comodo-toast-title",
  description: "comodo-toast-description",
  closeButton: "comodo-toast-close",
  actionButton: "comodo-toast-action",
  cancelButton: "comodo-toast-cancel",
  success: "comodo-toast-success",
  info: "comodo-toast-info",
  warning: "comodo-toast-warning",
  error: "comodo-toast-error",
  loading: "comodo-toast-loading",
} satisfies NonNullable<ToasterProps["toastOptions"]>["classNames"];

function isParticipantRoute(pathname: string) {
  return pathname === "/participate" || pathname.startsWith("/join");
}

export function AppToaster({ routePath }: AppToasterProps) {
  const { theme } = useTheme();
  const isParticipant = isParticipantRoute(routePath);
  const position: ToasterProps["position"] = isParticipant ? "top-center" : "bottom-left";
  const sonnerTheme: ToasterProps["theme"] = theme === "dragons-hoard" ? "dark" : "light";

  return (
    <SonnerToaster
      theme={sonnerTheme}
      position={position}
      closeButton
      expand={false}
      visibleToasts={3}
      duration={4200}
      gap={10}
      offset={isParticipant ? "12px" : "18px"}
      mobileOffset={{
        top: "calc(12px + env(safe-area-inset-top))",
        right: "12px",
        bottom: "12px",
        left: "12px",
      }}
      containerAriaLabel="Application notifications"
      toastOptions={{
        classNames: toastClassNames,
      }}
    />
  );
}
